import { render, staticRenderFns } from "./OptionsPopup.vue?vue&type=template&id=a56632ae"
import script from "./OptionsPopup.vue?vue&type=script&lang=js"
export * from "./OptionsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports